import React, {
  useState,
  useEffect,
  useCallback,
  updateState,
  useReducer,
  useContext,
  createContext,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { combineReducers, createStore } from "redux";
import birthdayToAge from "../function/birthdayToAge.js";
import getDay from "../function/getDay.js";
import reloadIcon from "../icon/reload.svg";
import searchIcon from "../icon/search.svg";
import FunBarClass from "./funBarClass.js";
import classIcon from "../icon/swimClass.svg";
import cancelIcon from "../icon/cancel.svg";
import saveIcon from "../icon/save.svg";
import dateDiff from "../function/dateDiff.js"; //日期差
import classReturnOption from "../function/classReturnOption.js"; //處理選單
import GetStudentListComponent from "../pages/getStudentListComponent.js";
import getUrl from "../function/getUrl.js"
import getClassData from "../function/getClassData.js"
import ClassStudentListViewComponent from "../pages/classStudentListViewComponent.js"
import ClassStudentListViewComponentReadOnly from "../pages/classStudentListViewComponentReadOnly.js"
import ClassDataViewComponent from "../pages/classDataViewComponent.js"
import checkLogin from "../function/checkLogin.js"
import { use } from "react";
var imgStyle = {
  width: "30px",
  height: "30px",
};

const url = getUrl()
const token=sessionStorage.getItem("token")

const GetHisotry = () => {
  checkLogin()
  const param = useParams();
  const classRecordDBID = param.classRecordDBID;
  const classDBID = param.classDBID;
  const [history,setHistory]= useState([]);
  useEffect(() => {
    fetch(`${url}/appGet/getHistory?classRecordDBID=${classRecordDBID}&token=${token}`)
      .then((res) => res.json())
      .then((json) => {
        console.log("Fetched class record:", json);
        setHistory(json);
      })
      .catch((error) => {
        console.error("Error fetching class record:", error);
      });
  }, [classRecordDBID]);

  return (
    <>
    <div className="mt-10">
      <a href={`/SingleClassView/${classDBID}`} className="btn btn-primary mb-2">回上一頁</a>
    <table className="table table-striped">
      <thead>
        <tr>
          <th>動作</th>
          <th>時間</th>
          <th>使用者</th>
     
        </tr>
      </thead>
      <tbody>
        {history.map((record, index) => (
          <tr key={index}>
            <td>{record.action}</td>
            <td>{record.createDate}</td>
            <td>{record.user}</td>
        
          </tr>
        ))}
      </tbody>  
    </table>
    
    
    </div>

    </>
  );
};



export default GetHisotry;
